import { useLocation } from "react-router";
import { useContent } from "../../../hooks/useContent";
import { Get404s } from "../../../queries/Get404s";
import { Loading } from "../Loading";
import { MediaItem } from "../MediaItem";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import {
  BLOCKS,
  Document as RichTextDocument,
} from "@contentful/rich-text-types";
import { Button } from "../core/Button";
import { Link } from "../core/Link";
import { DEFAULT_404 } from "./DEFAULT_404";
import { Helmet } from "react-helmet-async";
import { getSeededRandomIndex } from "../../../utils/getSeededRandomIndex";

export function NotFound() {
  const { pathname } = useLocation();
  const [response] = useContent({
    query: Get404s,
  });

  if (response.fetching || (!response.fetching && !response.data)) {
    return <Loading />;
  }

  const items = response.data?.contentType404PageCollection?.items;

  const randomIndex = getSeededRandomIndex(pathname, items?.length);

  const item = items?.[randomIndex] ?? DEFAULT_404;

  return (
    <>
      <Helmet>
        <title>{item.displayTitle}</title>
      </Helmet>
      <section className="aspect-video w-full dsk:min-h-full min-h-screen flex flex-col justify-center items-center relative gap-9">
        <MediaItem
          item={item.background}
          className="absolute inset-0 w-full h-full object-cover brightness-60"
          width={1920}
        />
        <div className="z-10 mt-auto">
          {item.title?.json != null ? (
            documentToReactComponents(item.title.json as RichTextDocument, {
              renderNode: {
                [BLOCKS.PARAGRAPH]: (_, children) => (
                  <h1 className="text-heading-1 whitespace-pre-wrap text-center">
                    {children}
                  </h1>
                ),
              },
            })
          ) : (
            <h1 className="text-display-caps">{item.displayTitle}</h1>
          )}
        </div>
        <div className="z-10">
          {item.body?.json != null &&
            documentToReactComponents(item.body.json as RichTextDocument, {
              renderNode: {
                [BLOCKS.PARAGRAPH]: (_, children) => (
                  <p className="text-body-regular">{children}</p>
                ),
              },
            })}
        </div>
        <div className="z-10 mt-auto mb-8">
          <Button asChild variant="light-on-blur">
            <Link href="/">{item.buttonText ?? "Back To Home"}</Link>
          </Button>
        </div>
      </section>
    </>
  );
}
